module.exports = __webpack_public_path__ + "img/spe1.203c6369.png";